export default {
  // control
  ctrlPanelDisplayed: false,
  activeSection: '',

  // data
  contactData: {
    id: '',
    business: '',
    legal_name: '',
    name: '',
    platform: '',
    phone: '',
    email: '',
    address: {
      city: '',
      line: '',
      postal_code: '',
      state: '',
      country: {
        country: '',
        code: '',
      },
    },
    meta_data: {
      country: {
        country: '',
        code: '',
      },
      custom_fields: {},
    },
    tags: [],
  },
  contactDataIsLoading: true,
  notes: {
    data: [],
    meta: {},
  },
  loadingNotes: false,
  notesViewActiveForContact: null,
  activeDetailsSection: null,
  addContact: null,
  deleteContact: {},

  apiError: {},
};
